var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgChatIcon = function SvgChatIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "auto",
    fill: "none",
    viewBox: "0 0 300 292",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FCF7EF",
    d: "M120 0h60a120.1 120.1 0 0 1 84.853 35.087A119.7 119.7 0 0 1 300 119.795a119.7 119.7 0 0 1-35.147 84.708A120.1 120.1 0 0 1 180 239.59V292C105 262.051 0 217.128 0 119.795a119.7 119.7 0 0 1 35.147-84.708A120.1 120.1 0 0 1 120 0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChatIcon);
export default ForwardRef;